<section>
  <div class="header">
    <h4 class="vertical-align">
      <div>{{ 'LOCATION.PIPES' | translate }}</div>
    </h4>
    <div class="vertical-align">
      <button mat-button
              [disabled]="this.loadingProduct"
              (click)="uploadProduct()">
        {{'MENU.SEND_PRODUCT_FOR_SELECT' | translate }}
      </button>
    </div>
  </div>
  <div class="table-container mat-elevation-z8">
    <table
      mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows>

      <ng-container
        *ngFor="let column of columnsToDisplay"
        matColumnDef="{{ column }}">
        <th mat-header-cell *matHeaderCellDef>
          <ng-container [ngSwitch]="column">
            <ng-template ngSwitchDefault>
              {{ getColumnHeaderName(column) }}
            </ng-template>
          </ng-container>
        </th>
        <td
          mat-cell *matCellDef="let element">
          <div class="wrap-cell" [ngSwitch]="column">
            <div class="cell">
              <ng-template ngSwitchCase="checkBox">
                <mat-checkbox
                  [(ngModel)]="element.checked"
                  type="checkbox"
                >
                </mat-checkbox>
              </ng-template>
              <ng-template ngSwitchCase="organization">
                {{element.pipe.organizationName}}
              </ng-template>
              <ng-template ngSwitchCase="pipe">
                <div [ngClass]="{'menu-loading': element.loading}">
                  <app-pipe
                    [pipe]="element.pipe"
                    [organization]="null"
                  >
                  </app-pipe>
                </div>
              </ng-template>
            </div>
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="columnsToDisplay; sticky: true">
      </tr>
      <tr
        mat-row
        *matRowDef="let element; columns: columnsToDisplay">
      </tr>
    </table>
  </div>
</section>
